import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { AnyARecord } from 'dns';
import { SharedService } from 'services';
import { UserStorageService } from '../../../../api-services/user-storage.service';
import { FileCategory, ngbModalOptions, ngbModalOptionsXL } from '../../../../shared/constant';
import { UploadAttachmentModalComponent } from '../../attachments/upload-attachment-modal/upload-attachment-modal.component';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { WritingCodeDocumentComponent } from 'components/after-login/main-appointments/writing-code-document/writing-code-document.component';

@Component({
  selector: 'app-sidepanel-attachments',
  templateUrl: './sidepanel-attachments.component.html',
  styleUrls: ['./sidepanel-attachments.component.css']
})
export class SidepanelAttachmentsComponent implements OnInit {

  isError = false;
  selectedFile: any = null;
  selectedFiles: FileList | null = null;
  fileId = 0;
  newUploadedFile = [];
  writingCodeAttachments = [] as any[];
  attachmentFile: {
    id: number,
    file: File,
    fileName: string,
    size: any,
    selectdlicenseNumber: any
    description: string,
    errorMessagesFileFormat?: string,
    errorMessagesFileSize?: string,
    errorMessagesFileType?: string
  }
  fileUploadValid = true;
  errorMessages = [];
  errorMessagesFileFormat = [];

  showArchived = false;
  @Input() userId!: number;
  @Input() carrierId: number;
  fileStoreTypeId = localStorage["fileStoreTypeId"];
  loggedInUserId = Number(localStorage.getItem('userId'));
  activeList: boolean = false;

  constructor(private modalService: NgbModal, private sharedService: SharedService, private userStorageService: UserStorageService) { }

  ngOnInit(): void {
    this.getContactUploadedLicenseFiles();
  }

  // ////////////////////////////////////////////////

  selectFiles(event) {
    this.fileUploadValid = true;
    this.newUploadedFile = [];
    this.selectedFiles = event.target.files;
     this.getSelectedFiles();
    this.GetValidFiles();

    if(this.fileUploadValid)
    {
       this.uploadFiles();
    }else{


       { 
          var modalRef = this.modalService.open(WritingCodeDocumentComponent, ngbModalOptionsXL);
          modalRef.componentInstance.onboardingUserDoc = false;
          // modalRef.componentInstance.onboardingUser = this.user;
          modalRef.componentInstance.newUploadedFiles=this.newUploadedFile;
          modalRef.componentInstance.showUploadWizard=false;
          
          modalRef.result.then(data => {
            if (data) {
              this.sharedService.refreshActivity();
              // this.getUserFiles();
            }
          })
          }


      
    }

  }


  uploadFiles() {
    debugger;
    this.errorMessages = [];
    this.sharedService.showLoader();
    var fileCategoryId = FileCategory.WritingCode
    var files = this.newUploadedFile;
    var formData = new FormData();

    for (var i = 0; i < this.newUploadedFile.length; i++) {
  
        formData.append('file', files[i].file, files[i].fileName);
        formData.append('fileName', files[i].fileName);
        formData.append('fileTypeId', '27');
        formData.append('carrierId', this.carrierId.toString());
        formData.append('description', files[i].description == "" ? "//" : files[i].description + '//');      
    }
      this.userStorageService.UploadContactFiles(this.userId, this.fileStoreTypeId, fileCategoryId, formData).subscribe(
        response => {
          if (response.toLowerCase() == "success") {
            this.getContactUploadedLicenseFiles()
            this.sharedService.showToastMessage("File(s) uploaded successfully");
           
          }
          else if (response.toLowerCase() == "nostorage") {
            this.errorMessages.push("Not enough storage to upload file(s).");
          }

          this.sharedService.hideLoader();

        },
        error => {
         // console.log(error);
          this.sharedService.hideLoader();
          this.errorMessages.push(error.message);
        });
    
  }


  openUploadPopup() {
    var fileCategory = {
      fileCategoryId: FileCategory.WritingCode,
      attachmentNoteId: this.carrierId
    }
    const modalRef = this.modalService.open(UploadAttachmentModalComponent, ngbModalOptionsXL);
    modalRef.componentInstance.selectedFiles = this.selectedFiles;
    // modalRef.componentInstance.userLicenseId = this.userId;
    modalRef.componentInstance.fileCategory = fileCategory;
    modalRef.result.then(data => {
      if (data) {
        this.getContactUploadedLicenseFiles();
      }
    })
  }
  getContactUploadedLicenseFiles() {
    var obj = {
      fileStoreTypeId: this.fileStoreTypeId,
      fileCategoryId: FileCategory.WritingCode,
      attachmentNoteId: this.carrierId
    }
    this.userStorageService.getContactUploadedFiles(obj, false).subscribe(
      (response: any) => {
        this.writingCodeAttachments = response

          //.filter(file => file.userLicenseId === this.userLicenseId)
          .map(el => ({
            ...el,
            localCreatedDate: this.sharedService.convertUTCTimeToLocalTime(el.createdDate)
          }));
        this.activeList = true;
      },
      (error: any) => {
        console.log(error);
      });
  }
  private GetValidFiles() {
    // this.isShow = true;
    this.isError = false;
    // this.newUploadedFile = [];
    this.errorMessagesFileFormat = [];

    let isValid = true;
    this.fileUploadValid = true;
    let invalidFileFormat = [];
    let invalidFileSize = [];
    const supportedExt = "application/pdf, image/jpg, image/jpeg, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"

    for (let i = 0; i < this.newUploadedFile.length; i++) {
      let file = this.newUploadedFile[i].file;

      let ext = file.type;
      let size = file.size;

      if (supportedExt.includes(ext)) {
        isValid = true;
        if (size > 10485760) {
          this.fileUploadValid = false;
          this.newUploadedFile[i].errorMessagesFileSize = "Invalid file size! Max file size 10Mb"
        }
      } else {
        this.fileUploadValid = false;
        this.newUploadedFile[i].errorMessagesFileFormat = "Invalid file format! Allowed file format is .pdf, .doc, .docx, .jpg, .jpeg, and .xlsx"
      }
    }

    this.newUploadedFile.forEach(el => {
      if (!this.isError && (el?.errorMessagesFileSize || el?.errorMessagesFileFormat)) {
        this.isError = true;
        return;
      }
    })

  }

  getSelectedFiles() {
    // this.newUploadedFile = [];
    for (let i = 0; i < this.selectedFiles.length; i++) {
      this.attachmentFile = {
        id: this.fileId++,
        // isLicenseDoc: true,
        file: this.selectedFiles[i],
        fileName: this.selectedFiles[i].name,
        // size: (this.selectedFiles[i].size / 1024 / 1024).toFixed(2),
        size: this.sharedService.FormatBytes(this.selectedFiles[i].size),
        // licenseNumber: this.licenseNumber,
        selectdlicenseNumber: null,
        description: ""
      };
      // this.ShowUploadWizard = false;
      this.newUploadedFile.push(this.attachmentFile);
    }
  }

  ShowArchivedAttachments(event) {
    this.showArchived = event.target.checked == true ? true : false
  }

  openDeleteConfirmationPopup(fileId, fileName, fileStoreTypeId) {
    var modalData = {
      title: "Delete Attachment",
      prompt: `Are you sure you want to delete attachment - <span class="bold-500">${fileName}</span> ?`
      // ${eandOAttachment.fileName}
    }
    const modalRef = this.modalService.open(ConfirmDialogComponent, ngbModalOptions);
    modalRef.componentInstance.modalData = modalData;

    modalRef.result.then(data => {
      if (data) {
        // this.deleteFileId = fileId;
        // this.deleteFileName = fileName;
        this.fileStoreTypeId = fileStoreTypeId;
        this.DeleteFile(fileId);
        // this.sharedService.showToastMessage("Attachment deleted successfully.");
      }
    });
  }
  DeleteFile(deleteFileId: any): void {
    this.sharedService.showLoader();
    this.userStorageService.deleteFileById(this.userId, deleteFileId, this.fileStoreTypeId, FileCategory.WritingCode).subscribe
      (response => {
        this.sharedService.hideLoader();
        this.getContactUploadedLicenseFiles();
        this.sharedService.showToastMessage("File deleted successfully");

      }),
      (error: any) => {
        console.log(error);
        this.sharedService.hideLoader();
      };
  }

  downloadFile(fileId, fileStorageTypeId): void {
    debugger;
    this.errorMessages = [];
    this.sharedService.showLoader();
    this.userStorageService.DownloadContactFile(this.userId, fileId, fileStorageTypeId, FileCategory.WritingCode).subscribe(
      response => {
        this.activeList = true;
        if (response.response.toLowerCase() == "filedeleted") {
          this.sharedService.hideLoader();
          this.errorMessages.push("This file does not exist.");
        }
        else {
          this.sharedService.hideLoader();
          let byteCharacters = atob(response.response);
          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++)
            byteNumbers[i] = byteCharacters.charCodeAt(i);

          let byteArray = new Uint8Array(byteNumbers);
          let blob = new Blob([byteArray], { type: response.contentType });

          if (response.contentType === "application/pdf") {
            var blobURL = URL.createObjectURL(blob);
            window.open(blobURL);
          }
          else {
            var blobURL = window.URL.createObjectURL(blob);
            var anchor = document.createElement("a");
            anchor.download = response.fileName;
            anchor.href = blobURL;
            anchor.click();
          }
        }
      }),
      (error: any) => {
        console.log(error);
        this.activeList = true;
        this.sharedService.hideLoader();
      };
  }

  bytesToMegabytes(bytes: number): string {
    const KB = 10 * 1024; // To convert byte into 10 kb
    const bytesInMB = 1024 * 1024;
    //If less than 10 kb 
    if (bytes < KB) return (bytes / 1024).toFixed(2) + ' KB';
    return (bytes / bytesInMB).toFixed(2) + ' MB';
  }
}
